/**
 * React Query hooks for notification settings.
 *
 * Provides:
 * - useNotificationSettings: query for the current telegram_chat_id
 * - useUpdateNotificationSettings: mutation to save/clear the chat id
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getNotificationSettings, updateNotificationSettings } from '../api/client';
import type { NotificationSettings } from '../api/client';

const NOTIFICATION_SETTINGS_KEY = ['notification-settings'] as const;

export function useNotificationSettings() {
  return useQuery({
    queryKey: NOTIFICATION_SETTINGS_KEY,
    queryFn: getNotificationSettings,
  });
}

export function useUpdateNotificationSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (settings: NotificationSettings) => updateNotificationSettings(settings),
    onSuccess: (data) => {
      queryClient.setQueryData(NOTIFICATION_SETTINGS_KEY, data);
    },
  });
}
